/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SrvProceedingAssetSnapshotExpenseResponse } from './SrvProceedingAssetSnapshotExpenseResponse';
import {
    SrvProceedingAssetSnapshotExpenseResponseFromJSON,
    SrvProceedingAssetSnapshotExpenseResponseFromJSONTyped,
    SrvProceedingAssetSnapshotExpenseResponseToJSON,
    SrvProceedingAssetSnapshotExpenseResponseToJSONTyped,
} from './SrvProceedingAssetSnapshotExpenseResponse';
import type { SrvProceedingMaintenanceExpenseResponse } from './SrvProceedingMaintenanceExpenseResponse';
import {
    SrvProceedingMaintenanceExpenseResponseFromJSON,
    SrvProceedingMaintenanceExpenseResponseFromJSONTyped,
    SrvProceedingMaintenanceExpenseResponseToJSON,
    SrvProceedingMaintenanceExpenseResponseToJSONTyped,
} from './SrvProceedingMaintenanceExpenseResponse';

/**
 * 
 * @export
 * @interface SrvProceedingAssetSnapshotResponse
 */
export interface SrvProceedingAssetSnapshotResponse {
    /**
     * 
     * @type {number}
     * @memberof SrvProceedingAssetSnapshotResponse
     */
    maintenanceObligationCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof SrvProceedingAssetSnapshotResponse
     */
    monthlyIncome: number | null;
    /**
     * 
     * @type {number}
     * @memberof SrvProceedingAssetSnapshotResponse
     */
    seizableAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SrvProceedingAssetSnapshotResponse
     */
    isAvailable: boolean;
    /**
     * 
     * @type {Array<SrvProceedingAssetSnapshotExpenseResponse>}
     * @memberof SrvProceedingAssetSnapshotResponse
     */
    expenses: Array<SrvProceedingAssetSnapshotExpenseResponse>;
    /**
     * 
     * @type {SrvProceedingMaintenanceExpenseResponse}
     * @memberof SrvProceedingAssetSnapshotResponse
     */
    maintenanceExpense: SrvProceedingMaintenanceExpenseResponse | null;
    /**
     * 
     * @type {number}
     * @memberof SrvProceedingAssetSnapshotResponse
     */
    totalExpenses: number;
}

/**
 * Check if a given object implements the SrvProceedingAssetSnapshotResponse interface.
 */
export function instanceOfSrvProceedingAssetSnapshotResponse(value: object): value is SrvProceedingAssetSnapshotResponse {
    if (!('maintenanceObligationCount' in value) || value['maintenanceObligationCount'] === undefined) return false;
    if (!('monthlyIncome' in value) || value['monthlyIncome'] === undefined) return false;
    if (!('seizableAmount' in value) || value['seizableAmount'] === undefined) return false;
    if (!('isAvailable' in value) || value['isAvailable'] === undefined) return false;
    if (!('expenses' in value) || value['expenses'] === undefined) return false;
    if (!('maintenanceExpense' in value) || value['maintenanceExpense'] === undefined) return false;
    if (!('totalExpenses' in value) || value['totalExpenses'] === undefined) return false;
    return true;
}

export function SrvProceedingAssetSnapshotResponseFromJSON(json: any): SrvProceedingAssetSnapshotResponse {
    return SrvProceedingAssetSnapshotResponseFromJSONTyped(json, false);
}

export function SrvProceedingAssetSnapshotResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SrvProceedingAssetSnapshotResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'maintenanceObligationCount': json['maintenanceObligationCount'],
        'monthlyIncome': json['monthlyIncome'],
        'seizableAmount': json['seizableAmount'],
        'isAvailable': json['isAvailable'],
        'expenses': ((json['expenses'] as Array<any>).map(SrvProceedingAssetSnapshotExpenseResponseFromJSON)),
        'maintenanceExpense': SrvProceedingMaintenanceExpenseResponseFromJSON(json['maintenanceExpense']),
        'totalExpenses': json['totalExpenses'],
    };
}

export function SrvProceedingAssetSnapshotResponseToJSON(json: any): SrvProceedingAssetSnapshotResponse {
    return SrvProceedingAssetSnapshotResponseToJSONTyped(json, false);
}

export function SrvProceedingAssetSnapshotResponseToJSONTyped(value?: SrvProceedingAssetSnapshotResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maintenanceObligationCount': value['maintenanceObligationCount'],
        'monthlyIncome': value['monthlyIncome'],
        'seizableAmount': value['seizableAmount'],
        'isAvailable': value['isAvailable'],
        'expenses': ((value['expenses'] as Array<any>).map(SrvProceedingAssetSnapshotExpenseResponseToJSON)),
        'maintenanceExpense': SrvProceedingMaintenanceExpenseResponseToJSON(value['maintenanceExpense']),
        'totalExpenses': value['totalExpenses'],
    };
}

